import React from 'react';
import {
  BasicSettings,BaseToolbarDimension,BaseToolbarMarginOrPadding,BaseToolbarInputGroup, BaseInput, BaseToolbarSelect, BaseToolbarJson,
} from 'wsc-react-custom-form';
export const FormDateTimeSelectSettings = () => {
  return (
    <React.Fragment>
      {/* <BasicSettings /> */}
      <BaseToolbarDimension />
            <BaseToolbarMarginOrPadding name='margin' />
            <BaseToolbarMarginOrPadding name='padding' />
      <BaseToolbarInputGroup>
        {/*  widthRation可选：不填的话，label宽度占30%；填写的值在1-99之间*/}
        <BaseInput propKey='name' label='Name' tooltipTitle='存储表单值的key' widthRation={50} />
        <BaseInput propKey='label' label='Label' tooltipTitle='标签' widthRation={50} />
        <BaseToolbarSelect
          propKey='showLabel'
          label='显示Label'
          tooltipTitle='是否显示标签'
          options={[
            { value: 'true', label: '显示' },
            { value: 'false', label: '不显示' }
          ]}
          widthRation={50}
        />
        <BaseInput propKey='labelSpan' label='labelSpan' tooltipTitle='标签宽度（labelSpan）' widthRation={50} />
        <BaseInput propKey='labelOffset' label='labelOffset' tooltipTitle='标签偏移量（labelOffset）' widthRation={50} />
        <BaseInput propKey='wrapperSpan' label='wrapperSpan' tooltipTitle='表单组件宽度（wrapperSpan）' widthRation={50} />
        <BaseInput propKey='wrapperOffset' label='wrapperOffset' tooltipTitle='表单组件偏移量（wrapperOffset）' widthRation={50} />
        <BaseToolbarJson propKey="rules" label='校验规则' tooltipTitle='表单组件的校验规则' widthRation={50} />

        <BaseToolbarSelect
          propKey='disabled'
          label='禁用'
          tooltipTitle='是否禁用编辑'
          options={[
            { value: 'true', label: '禁用' },
            { value: 'false', label: '不禁用' },
          ]}
          widthRation={30}
        />

        <BaseInput propKey='format' label='日期格式' tooltipTitle='日期格式' />
        <BaseInput propKey='timeFormat' label='时间格式' tooltipTitle='时间格式' />
        <BaseInput propKey='hourStep' label='小时选项间隔' tooltipTitle='小时选项间隔' />
        <BaseInput propKey='minuteStep' label='分钟选项间隔' tooltipTitle='分钟选项间隔' />
        <BaseInput propKey='secondStep' label='秒选项间隔' tooltipTitle='秒选项间隔' />
      </BaseToolbarInputGroup>

    </React.Fragment>
  );
};
